module.exports = __webpack_public_path__ + "static/media/STAF_bokmål_sekundærlogo_neg(hvit).33a16ba6.pdf";